import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Loader } from '../../../utils/loader.util';
import { TableActionService } from '../services/table-action.service';
import { ColumnConfiguration } from './column-config.model';
import { TableEvent } from './table-event.model';

export type DataSourceRequester = (filter: {
  offset: number,
  limit: number,
  filter: unknown,
}) => Observable<IResponse<unknown>>;

export type CounterDataSourceRequester = (
) => Observable<IResponse<unknown>>;

export class TableConfiguration {
  id?: string;
  classes?: Record<string, unknown> = {};
  getDataSource: DataSourceRequester;
  // getCounterDataSource?: CounterDataSourceRequester;
  mapData: (data: unknown[], config?: TableConfiguration) => unknown[];
  columns: ColumnConfiguration[] = [];
  events?: Subject<TableEvent> = new Subject();
  dataCounterSource?: Observable<{count: number}>;
  dataCounter?: BehaviorSubject<number> = new BehaviorSubject(0);
  loader?: Loader = Loader.create().add('configurable-table-loading');
  context?: Record<string, unknown> = {};
  barConfig?: BarConfig;
  cacheKey?: string;

  tableCallbacks?: Record<string, (...args: unknown[]) => unknown> = {};
  actionExecuter?: TableActionService;

  constructor(config: TableConfiguration) {
    Object.assign(this, config)
  }

  static create(config: TableConfiguration) {
    return new TableConfiguration(config);
  }
}

export class BarConfig {
  header: unknown;
  actions: unknown;
}

export interface IResponse<T> {
  count: number;
  data: T[];
}